import Select from "../components/Select";
import PrimaryButton from "../components/Submit";
import FormHeader from "../components/FormHeader";
import Banner from "../components/Banner.tsx";

type IProps = {
  onNext: () => void;
  currentIndex: number;
  totalSteps: number;
};

function FinancialBackground(props: IProps) {
  return (
    <div className="form-container">
      <FormHeader title="Financial Background" />
      <Banner
        body="As a company regulation by the Financial Conduct Authority, we’re required to assess if our products are appropriate for you, so please answer honestly"
        variant={"info"}
      />
      <form action="#" method="POST" onSubmit={(e) => e.preventDefault()}>
        <Select
          label="Annual income (GBP)"
          placeholder="Select your annual income"
          className="select-full"
          options={[
            { key: "0-25k", value: "£0 - £25,000" },
            { key: "25k-50k", value: "£25,000 - £50,000" },
            { key: "50k-100k", value: "£50,000 - £100,000" },
            { key: "100k-250k", value: "£100,000 - £250,000" },
            { key: "250k+", value: "£250,000+" },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
        />

        <Select
          label="Value of savings and investments (GBP)"
          placeholder="Select value of savings and investments"
          className="select-full"
          options={[
            { key: "0-10k", value: "£0 - £10,000" },
            { key: "10k-50k", value: "£10,000 - £50,000" },
            { key: "50k-100k", value: "£50,000 - £100,000" },
            { key: "100k-500k", value: "£100,000 - £500,000" },
            { key: "500k+", value: "£500,000+" },
          ]}
          updateFieldValue={() => {}}
          triggerFieldChange={() => {}}
        />

        <PrimaryButton type="button" onClick={props.onNext} loading={false}>
          Next
        </PrimaryButton>
      </form>
    </div>
  );
}

export default FinancialBackground;
